<script>
import dialog from '@/components/Dialog'
import moment from 'moment'
// import apiConfig from '../../config/api.config'
export default {
  components: {'v-dialog': dialog},
  props: {
    // 是否为出力
    isPrint: {
      type: Boolean,
      default: false
    },
    // 车辆集合
    vehicleList: {
      type: Array,
      default: function () {
        return []
      }
    },
    // 当前日期
    currentDate: {
      type: Date,
      default: () => { return new Date() }
    },
    // 是否加载成功
    loading: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      // 日
      date: this.currentDate.getDate(),
      // 年
      year: this.currentDate.getFullYear(),
      // 月
      month: this.currentDate.getMonth() + 1,
      // 当前年月
      nowmonth: this.currentDate.getFullYear() + '年' + (this.currentDate.getMonth() + 1) + '月',
      // block颜色
      colors: ['', 'bgc1', 'bgc4', 'bgc9', 'lh-color4', 'stop-color'],
      weeks: [
        '日',
        '月',
        '火',
        '水',
        '木',
        '金',
        '土'
      ],
      // 7天block具体日期内容
      content: [],
      // 出力Dialog
      showPrintDialog: false,
      dialogPrintOption: {
        showNo: true,
        text: 'データをダウンロードします。<br/>よろしいですか？',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      },
      allCheck: false
    }
  },
  // 初始化日期 checkList
  created: function () {
    let year = this.year
    let month = this.month
    let day = this.date
    let dM = new Date(year, month - 1, 0)
    let maxDays = dM.getDate()

    for (let i = -3; i < 4; i++) {
      let tempDay
      if (day - 3 <= 0) {
        let t = i + 3
        tempDay = day + t
      } else if (day + 3 > maxDays) {
        let t = i - 3
        tempDay = day + t
      } else {
        tempDay = day + i
      }
      let d = new Date(year, month - 1, tempDay)
      let item = {
        year: year,
        month: month,
        date: tempDay,
        week: this.weeks[d.getDay()]
      }
      this.content.push(item)
    }
  },
  computed: {
    checkList: function () {
      let checkList = []
      for (let i = 0; i < this.vehicleList.length; i++) {
        checkList.push(false)
      }
      return checkList
    }
  },
  methods: {
    // 获取日期
    getDate () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      this.nowmonth = year + '年' + month + '月'
      this.date = day
    },
    // 改变7天content内的日期
    changeContent (year, month) {
      for (let i = 0; i < 7; i++) {
        this.content[i].date = i + 1
        let d = new Date(year, month - 1, this.content[i].date)
        this.content[i].week = this.weeks[d.getDay()]
        this.content[i].year = year
        this.content[i].month = month
      }
    },
    // 减一天
    leftcontent (value) {
      // let date = new Date()
      let year = this.year
      let month = this.month
      if (value > 1) {
        for (let i = 0; i < 7; i++) {
          this.content[i].date--
          let d = new Date(year, month - 1, this.content[i].date)
          this.content[i].week = this.weeks[d.getDay()]
        }
      }
      sessionStorage.setItem('vehicleCurrentDate', moment([year, month - 1, this.content[3].date]).format('YYYYMMDD'))
    },
    // 加一天
    rightcontent (value) {
      // let date = new Date()
      let year = this.year
      let month = this.month
      let d = new Date(year, month, 0)
      let maxDays = d.getDate()
      if (value < maxDays) {
        for (let i = 0; i < 7; i++) {
          this.content[i].date++
          let d = new Date(year, month - 1, this.content[i].date)
          this.content[i].week = this.weeks[d.getDay()]
        }
      }
      sessionStorage.setItem('vehicleCurrentDate', moment([year, month - 1, this.content[3].date]).format('YYYYMMDD'))
    },
    // 减一月
    leftnowmonth () {
      if (this.month === 1) {
        this.month = 12
        this.year--
      } else { this.month-- }
      this.nowmonth = this.year + '年' + this.month + '月'
      this.changeContent(this.year, (this.month))
      sessionStorage.setItem('vehicleCurrentDate', moment([this.year, this.month - 1, this.content[3].date]).format('YYYYMMDD'))
    },
    // 加一月
    rightnowmonth () {
      if (this.month === 12) {
        this.month = 1
        this.year++
      } else { this.month++ }
      this.nowmonth = this.year + '年' + this.month + '月'
      this.changeContent(this.year, (this.month))
      sessionStorage.setItem('vehicleCurrentDate', moment([this.year, this.month - 1, this.content[3].date]).format('YYYYMMDD'))
    },
    // 判断当前时间段是否有便
    hasShiftInfo (vehicleInfo, content, timeFlag) {
      if (!vehicleInfo.shiftInfos) { return {color: 0, shiftId: null} }
      // 设置时间区域
      let contentStartTime = null
      let contentEndTime = null
      switch (timeFlag) {
        case 1:
          contentStartTime = moment([content.year, content.month - 1, content.date, 0])
          contentEndTime = moment([content.year, content.month - 1, content.date, 5, 59, 59])
          break
        case 2:
          contentStartTime = moment([content.year, content.month - 1, content.date, 6])
          contentEndTime = moment([content.year, content.month - 1, content.date, 11, 59, 59])
          break
        case 3:
          contentStartTime = moment([content.year, content.month - 1, content.date, 12])
          contentEndTime = moment([content.year, content.month - 1, content.date, 17, 59, 59])
          break
        default:
          contentStartTime = moment([content.year, content.month - 1, content.date, 18])
          contentEndTime = moment([content.year, content.month - 1, content.date, 23, 59, 59])
      }
      // 判断便区域
      for (let shiftInfo of vehicleInfo.shiftInfos) {
        if (!shiftInfo.startTime || !shiftInfo.arriveTime || shiftInfo.startTime.length !== 14 || shiftInfo.arriveTime.length !== 14) continue

        let startDateTime = moment(shiftInfo.startTime, 'YYYYMMDDHHmmss')
        let arriveDateTime = moment(shiftInfo.arriveTime, 'YYYYMMDDHHmmss')

        if (!(startDateTime.isAfter(contentEndTime) || arriveDateTime.isBefore(contentStartTime))) {
          if (shiftInfo.coercionStopFlag === 1) {
            return {color: 5, shiftId: shiftInfo.shiftId}
          }
          return {color: shiftInfo.businessStatus, shiftId: shiftInfo.shiftId}
        }
      }
      let blockStartTime
      let blockEndTime
      if (vehicleInfo.blockStart && vehicleInfo.blockEnd) {
        blockStartTime = moment(vehicleInfo.blockStart, 'YYYYMMDDHHmmss')
        blockEndTime = moment(vehicleInfo.blockEnd, 'YYYYMMDDHHmmss')
        if (!(blockStartTime.isAfter(contentEndTime) || blockEndTime.isBefore(contentStartTime))) {
          return {color: 4, shiftId: null}
        }
      }

      return {color: 0, shiftId: null}
    },
    // 跳转到车辆详细页面
    goDetail (vehicleInfo) {
      let vehicle = {
        vehicleName: vehicleInfo.vehicleName,
        vehicleId: vehicleInfo.vehicleId,
        displayVehicleId: vehicleInfo.displayVehicleId,
        vehicleType: vehicleInfo.vehicleType,
        vehiclePlate: vehicleInfo.vehiclePlate,
        passengerNumber: vehicleInfo.passengerNumber,
        joinDate: vehicleInfo.joinDate,
        note: vehicleInfo.note,
        vehiclePhotoUrl: vehicleInfo.vehiclePhotoUrl,
        blockStart: vehicleInfo.blockStart,
        blockEnd: vehicleInfo.blockEnd,
        blockNote: vehicleInfo.blockNote,
        transportKind: vehicleInfo.transportKind,
        transportId: vehicleInfo.transportId,
        transportName: vehicleInfo.transportName
      }
      sessionStorage.setItem('vehicleDetail', JSON.stringify(vehicle))
      this.$router.push({name: 'VehicleDetail'})
    },
    // 跳转到便详细
    goShiftDetail (vehicleInfo, content, timeFlag) {
      let shiftId = this.hasShiftInfo(vehicleInfo, content, timeFlag).shiftId
      if (shiftId !== null) {
        this.$router.push({name: 'MovementShiftDetail', query: {shiftId: shiftId, from: 'VehicleList'}})
      }
    },
    // 出力
    print () {
      let printList = []
      for (let i = 0; i < this.vehicleList.length; i++) {
        if (this.checkList[i]) {
          printList.push(this.vehicleList[i])
        }
      }
      if (printList.length === 0) {
        this.dialogPrintOption.text = '車両リストを選択してください。'
        this.dialogPrintOption.showNo = false
        this.dialogPrintOption.confirmButtonText = 'OK'
      } else {
        this.dialogPrintOption.text = 'データをダウンロードします。<br/>よろしいですか？'
        this.dialogPrintOption.showNo = true
        this.dialogPrintOption.cancelButtonText = 'キャンセル'
        this.dialogPrintOption.confirmButtonText = '実行'
      }
      this.showPrintDialog = true
      this.$refs.printDialog.confirm().then(() => {
        if (printList.length !== 0) {
          this.$axios.post('vehicle/exportVehicleCsv', printList, {responseType: 'arraybuffer'}).then((res) => {
            let fileName = '車両リスト.csv'
            let blob = new Blob([res.data], { type: 'application/x-xls' })
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName)
            } else {
              var link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = fileName
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
          }).catch((error) => {
            console.log(error)
            let dialogPrintOption = {
              showNo: false,
              text: '予期せぬエラーが発生しました。',
              confirmButtonText: 'OK'
            }
            this.dialogPrintOption = dialogPrintOption
            this.showPrintDialog = true
            this.$refs.printDialog.confirm().then(() => {
              this.showPrintDialog = false
            })
          })
        }

        this.showPrintDialog = false
      }).catch(() => {
        this.showPrintDialog = false
      })
    },
    cancel () {
      for (let i = 0; i < this.checkList.length; i++) {
        this.checkList[i] = false
      }
      this.$emit('cancelPrint')
    }
  },
  watch: {
    allCheck: function () {
      if (this.allCheck) {
        for (let i = 0; i < this.checkList.length; i++) {
          this.checkList[i] = true
        }
      } else {
        for (let i = 0; i < this.checkList.length; i++) {
          this.checkList[i] = false
        }
      }
    }
  }
}
</script>

<template>
  <div  style="height:calc(100% - 75px);">
    <div class="col-md-12 column" style="height: 100%">
      <div class="row clearfix" style="height: 100%">
        <div class="col-md-12 column" style="height: 100%; display: flex; flex-direction: column;">
          <!-- month title -->
          <div class="row clearfix lh9-title bgc1">
            <div class="col-md-4 column">
            </div>
            <div class="col-md-4 column">
              <div class="row clearfix month-title">
                <div class="col-md-3 column">
                  <img v-show="!isPrint" src="@/assets/button/triangle_white_button_left.png" @click="leftnowmonth" class="img-style"
                    style="float:right;">
                </div>
                <div class="col-md-6 column nowmonth F2-R-22">{{nowmonth}}</div>
                <div class="col-md-3 column">
                  <img v-show="!isPrint" src="@/assets/button/triangle_white_button_right.png" @click="rightnowmonth" class="img-style"
                    style="float:left;">
                </div>
              </div>
            </div>
          </div>
          <!-- day title -->
          <div class="row clearfix">
            <div class="col-md-12 column date-div bgc5" :style="vehicleList.length>3?'padding-right:5px':''">
              <div class="row clearfix">
                <!-- AllCheck -->
                <div v-show="isPrint" class="col-md-1 column print-day-div">
                    <div style="display: flex;justify-content: center;align-items: center;padding-left:10px;height:100%">
                      <input type="checkbox" v-model="allCheck" style="height:20px;width:20px;margin-left:-10px;">
                    </div>
                </div>
                <!-- LeftDiv -->
                <div class="col-md-3 column left-div" :style="isPrint?'width:18%':'width:22%'">
                </div>
                <!-- RightDiv -->
                <div class="col-md-9 column right-div">
                  <div class="row clearfix">
                    <div class="col-md-2 column shift-div" v-for="n in 7" :key="n">
                      <div class="row clearfix">
                        <div class="col-md-12 column">
                          <div class="row clearfix week-title">
                            <div class="col-md-3 column">
                              <img v-if="n===1&&!isPrint" src="@/assets/button/triangle_blue_left_button.png" class="img-style" @click="leftcontent(content[0].date)">
                            </div>
                            <div class="col-md-6 column" style="width:40%">
                              <div class="row clearfix">
                                <div class="col-md-12 column date-style F3-R-27">
                                  {{content[n-1].date}}
                                </div>
                              </div>
                              <div class="row clearfix">
                                <div class="col-md-12 column week-font-style F3-R-16">
                                  ({{content[n-1].week}})
                                </div>
                              </div>
                            </div>
                            <div class="col-md-3 column">
                              <img v-if="n===7&&!isPrint" src="@/assets/button/triangle_blue_right_button.png" class="img-style" @click="rightcontent(content[6].date)">
                            </div>
                          </div>
                          <div class="row clearfix">
                            <div class="col-md-6 column lh9-left am-style F3-R-16">
                              AM
                            </div>
                            <div class="col-md-6 column pm-style F3-R-16">
                              PM
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- body -->
          <div class="list-body slider row" style="overflow-y:auto" v-loading="loading" element-loading-text="ローディング中">
            <div class="row clearfix" v-for="(vehicleInfo,index) in vehicleList" :key="index">
              <div class="col-md-12 column vehicle-list-style">
                <div class="row clearfix">
                  <!-- left part -->
                  <div v-show="isPrint" class="col-md-1 column print-div bgc8">
                    <div style="display: flex;justify-content: center;align-items: center;padding-left:10px;height:100%">
                      <input type="checkbox" v-model="checkList[index]" style="height:20px;width:20px;margin-left:-10px;">
                    </div>
                  </div>
                  <div class="col-md-2 column bgc8" style="text-align:left;height: 105px;" :style="isPrint?'width:18%':'width:22%'">
                    <div class="row clearfix" style="padding-left:15px;">
                      <div class="col-md-12 column">
                        <!-- 车辆名 -->
                        <div class="row clearfix left-text vehicle-name">
                          <div class="col-md-12 column F3-M-22 tooLong" :title="vehicleInfo.vehicleName">
                            <img src="../assets/icon/transport_kind0.png" style="margin-right: 2px; height: 32px;width:32px;" v-if="vehicleInfo.transportKind=='0'">
                            <img src="../assets/icon/transport_kind1.png" style="margin-right: 2px; height: 32px;width:32px;" v-if="vehicleInfo.transportKind=='1'">
                            {{vehicleInfo.vehicleName}}
                          </div>
                        </div>
                        <!-- ID车牌 -->
                        <div class="row clearfix vehicle-id">
                          <div class="col-md-12 column">
                            <div class="col-md-2 column F3-R-17" style="padding:0px;">ID:{{vehicleInfo.displayVehicleId}}</div>
                            <div v-if="!isPrint" class="col-md-10 column F3-R-17 tooLong" style="padding:0px;" :title="vehicleInfo.vehiclePlate">{{vehicleInfo.vehiclePlate}}</div>
                          </div>
                        </div>
                        <div class="row clearfix left-text">
                          <div class="col-md-12 column">
                            <div v-if="isPrint">{{vehicleInfo.vehiclePlate}}</div>
                            <button v-if="!isPrint" class="btn btn-default lh9-btn F2-R-17" @click="goDetail(vehicleInfo)">詳細</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 7天的内容 -->
                  <div class="col-md-9 column right-div">
                    <div class="row clearfix">
                      <div class="col-md-2 column shift-div shift-info bgc11" v-for="n in 7" :key="n">
                        <div class="col-md-6 column shift-item"
                        :class="[colors[hasShiftInfo(vehicleInfo,content[n-1],1).color]]"
                        @click="goShiftDetail(vehicleInfo,content[n-1],1)">

                        </div>
                        <div class="col-md-6 column lh9-left shift-item"
                        :class="[colors[hasShiftInfo(vehicleInfo,content[n-1],2).color]]"
                          @click="goShiftDetail(vehicleInfo,content[n-1],2)">

                        </div>
                        <div class="col-md-6 column shift-item"
                        :class="[colors[hasShiftInfo(vehicleInfo,content[n-1],3).color]]"
                        @click="goShiftDetail(vehicleInfo,content[n-1],3)">
                        </div>
                        <div class="col-md-6 column shift-item"
                        :class="[colors[hasShiftInfo(vehicleInfo,content[n-1],4).color]]"
                        @click="goShiftDetail(vehicleInfo,content[n-1],4)">

                        </div>
                      </div>
                      <div class="col-md-2 column" style="width:0%"></div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
          <!-- bottom label -->
          <div class="row clearfix bottom-label">
            <div class="col-md-2 column"></div>
            <div class="col-md-8 column">
              <div class="col-md-3 column" style="width:20%">
                <div class="lh-block lh-color1 bgc1"></div>
                業務予定
              </div>
              <div class="col-md-3 column" style="width:20%">
                <div class="lh-block lh-color2 bgc4"></div>
                業務中
              </div>
              <div class="col-md-3 column" style="width:20%">
                <div class="lh-block lh-color3 bgc9"></div>
                業務済
              </div>
              <div class="col-md-3 column" style="width:20%">
                <div class="lh-block stop-color"></div>
                停止
              </div>
              <div class="col-md-3 column" style="width:20%">
                <div class="lh-block lh-color3 lh-color4"></div>
                ブロック
              </div>
            </div>
          </div>
          <!-- footer -->
          <div class="row clearfix footer" v-show="isPrint">
            <div class="col-md-6 column">
              <button class="vehicle-button" style="float:right" @click="print">出力</button>
            </div>
            <div class="col-md-6 column">
              <button class="vehicle-button" style="float:left" @click="cancel">キャンセル</button>
            </div>
          </div>
          <v-dialog v-show="showPrintDialog" :dialog-option="dialogPrintOption" ref="printDialog"></v-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../assets/css/C00.css";
  .month-title{
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .week-title{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .radius {
    width: 60px;
    background: rgb(109, 109, 109);
    border-radius: 30px;
    color: #ffffff;
    text-align: center;
    font-size: 8px;
    margin-left: 5px;
  }
  .table>tbody>tr>td{
    border-bottom: 1.8px dashed rgb(109, 109, 109);
    border-top: 0px;
  }
  .date-div{
    background: #e0e0e0;
    border-bottom:#fff solid 5px;
    padding: 0px;
    /* padding-right:6px; */
  }
  .left-div{
    width:22%;
  }
  .right-div{
    width: 78%;
  }
  .date-style{
    font-size: 25px;
    padding-left: 0px;
    padding-right: 0px;
  }
  .week-font-style{
    font-size: 15px;
    padding-bottom:5px;
    padding-left: 0px;
    padding-right: 0px;
  }
  .shift-div{
    width: 14.1%;
    /* margin-left:2px; */
  }
  .shift-item{
    height:100%;
    padding-left:0px;
    padding-right:0px;
    width:25%;
  }
  .img-style{
    width: 15px;
  }
  .am-style{
    font-size:15px;
    border-left:#fff solid 2px;
  }
  .pm-style{
    font-size:15px;
  }
  .print-div{
    height:105px;
    width:4%;
    border-right:#fff solid 2px;
    padding:0px;
    padding-left: 15px;
  }
  .print-day-div{
    height: 87px;
    width:4%;
    border-right:#fff solid 2px;
    padding:0px;
    padding-left: 15px;
  }

  .vehicle-name{
    height:30%;
    font-size:20px;
    padding-bottom:0px;
  }
  .vehicle-id{
    height:30%;
    font-size:16px;
  }
  .shift-info{
    padding-top:30px;
    height:105px;
    border-left:#fff solid 2px;
    padding-left:0px;
    padding-right:0px;
  }
  .lh9-left{
    border-right: 1px dashed #ffffff;
  }
  .lh9-title{
    background: rgb(145, 145, 145);
    font-size: 16px;
  }
  .nowmonth{
    color: #ffffff;
    font-size: 20px;
  }
  .lh9-btn{
    width: 100%;
    height: 30px;
    background: linear-gradient(rgb(167, 167, 165) 50%, rgb(145,146,141) 50%);
    color: #ffffff;
    font-size: 15px;
    font-weight: 540;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .lh-block{
    display: inline-flex;
    width: 50px;
    height: 10px;
  }
  .lh-color1{
    background: rgb(199, 199, 199);
  }
  .lh-color2{
    background: rgb(159, 159, 159);
  }
  .lh-color3{
    background: rgb(138, 138, 138);
  }
  .lh-color4{
    background: rgb(230, 140, 30);
  }
  .stop-color{
    background: rgb(220, 30, 30);
  }
  .left-text{
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .vehicle-list-style{
    background:#cecece;
    border-bottom:#fff solid 5px;
    height:110px;
  }
  .list-body{
    flex: 1;
    /* height: 40vh; */
    height: calc(100% - 180px);
  }
  .bottom-label{
    background: #fff;
    border: rgb(180, 180, 180) solid 1px;
    margin-top: 20px;
    font-size: 1.8rem;
    padding: 5px;
  }
  .footer{
    /* position: fixed; */
    /* bottom: 50px; */
    margin: 10px 0 0 0;
    width: 100%;
  }
  .vehicle-button{
    width: 60%;
    height: 50px;
    border-radius: 10px;
    background: linear-gradient(#70b6ca 50%, #48a3be 50%) !important;
    border: 0px;
    /* margin: 30px; */
    font-size: 22px;
    color: #fff;
    background-color: #717171;
  }
  .tooLong{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media screen and (max-device-width: 1480px) {
    .date-style{
      font-size: 21px;
    }
    .am-style{
      font-size: 11px;
    }
    .pm-style{
      font-size: 11px;
    }
    .bottom-label{
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VehicleListComponent.vue